import {
  UPDATE_DEPLOYMENT,
  SET_DEPLOYMENTS,
  SET_DEPLOYMENT_MODBUS,
  SET_DEPLOYMENT_DISCOVERY,
  SET_HEARTBEATS,
  SET_DEPLOYMENT_CONFIG,
} from './actiontypes';
import {
  getDeployments,
  getDeploymentModbus,
  patchDeployment,
  upsertDeployment,
  getDeploymentConfig,
  upsertDeploymentConfig,
  createDeploymentCollector,
  updateDeploymentCollector,
  upsertModbusDeployment,
  deleteModbusDeployment,
  getDiscovery,
  postDiscovery,
  getSiteHeartbeats,
  associateBuildings,
} from '../../api/Api';
import { sendData } from './util';

export const getDeploymentsAction = () => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return getDeployments(jwt).then((data) => dispatch(sendData(SET_DEPLOYMENTS, data)));
};

export const getDeploymentModbusAction = (site) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return getDeploymentModbus(jwt, site).then((data) =>
    dispatch({ type: SET_DEPLOYMENT_MODBUS, site, data: data.modbus_deployments })
  );
};

export const getDeploymentDiscoveryAction = (site) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return getDiscovery(jwt, site).then((data) =>
    dispatch({ type: SET_DEPLOYMENT_DISCOVERY, site, data: data.bacnet_discovery })
  );
};

export const startDeploymentDiscoveryAction =
  (site, buildingId, port, min, max) => (dispatch, getState) => {
    const {
      user: { jwt },
    } = getState();
    return postDiscovery(jwt, site, buildingId, port, min, max).then(() =>
      dispatch(getDeploymentDiscoveryAction(site))
    );
  };

export const getHeartbeatsAction =
  (site, force = false) =>
  (dispatch, getState) => {
    const {
      user: { jwt },
      entities: {
        deployments: { heartbeats },
      },
    } = getState();
    const siteBeats = heartbeats[site];
    // If we have already loaded into redux, don't reload
    if (!force && siteBeats) return Promise.resolve();
    return getSiteHeartbeats(jwt, site, '72h').then((hbs) =>
      dispatch(sendData(SET_HEARTBEATS, { site, heartbeats: hbs }))
    );
  };

export const getDeploymentConfigAction =
  (site, force = false) =>
  (dispatch, getState) => {
    const {
      user: { jwt },
      entities: {
        deployments: { configs },
      },
    } = getState();
    const siteConfigs = configs[site];
    // If we have already loaded into redux, don't reload
    if (!force && siteConfigs) return Promise.resolve();
    return getDeploymentConfig(jwt, site).then((data) =>
      dispatch(sendData(SET_DEPLOYMENT_CONFIG, data))
    );
  };

const DEPLOYMENT_READ_ONLY_FIELDS = ['device_ips', 'buildings', 'last_heartbeat', 'id'];

export const upsertDeploymentAction = (deployment) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  const payload = { ...deployment };
  DEPLOYMENT_READ_ONLY_FIELDS.forEach((f) => {
    delete payload[f];
  });
  return upsertDeployment(jwt, payload).then(() => dispatch(getDeploymentsAction()));
};

export const patchDeploymentAction = (site, newName) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  const payload = { name: newName };
  return patchDeployment(jwt, site, payload).then((response) =>
    dispatch(sendData(UPDATE_DEPLOYMENT, response))
  );
};

const COLLECTOR_READ_ONLY_FIELDS = [
  'site',
  'private_ip',
  'api_key',
  'device_ips',
  'wg_pubkey',
  'last_heartbeat',
];

export const updateDeploymentCollectorAction = (collector) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  const payload = { ...collector };
  COLLECTOR_READ_ONLY_FIELDS.forEach((f) => {
    delete payload[f];
  });
  return updateDeploymentCollector(jwt, collector.site, collector.collector_id, payload).then(() =>
    dispatch(getDeploymentConfigAction(collector.site, true))
  );
};

export const createDeploymentCollectorAction = (site, config) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return createDeploymentCollector(jwt, site, config).then((result) => {
    dispatch(getDeploymentConfigAction(site, true));
    return result;
  });
};

export const upsertDeploymentConfigAction = (site, config) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return upsertDeploymentConfig(jwt, site, config).then(() =>
    dispatch(getDeploymentConfigAction(site, true))
  );
};

export const upsertModbusDeploymentAction = (site, modbusConfig) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return upsertModbusDeployment(jwt, site, modbusConfig).then(() =>
    dispatch(getDeploymentModbusAction(site))
  );
};

export const deleteModbusDeploymentAction = (site, modbusConfig) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return deleteModbusDeployment(
    jwt,
    site,
    modbusConfig.ip,
    modbusConfig.port,
    modbusConfig.unit
  ).then(() => dispatch(getDeploymentModbusAction(site)));
};

// eslint-disable-next-line import/no-unused-modules
export const associateBuildingsAction = (site, buildings) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return associateBuildings(jwt, site, buildings).then(() => dispatch(getDeploymentsAction()));
};
